/**
 * @file FindInSearchButton.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-30
 * @modified 2026-09-30
 * @description The "Find in …" button for an entity modal: takes the user to
 *              the record's own search screen with it searched for. Renders
 *              nothing when there is no record yet, or when the user is already
 *              on that screen (hooks/useOpenInSearch).
 *
 *   variant "slideout" (default) — for a modal footer; measures itself, so it
 *                                  works in a footer that does not.
 *   variant "icon"               — for a header's icon row (Contact modal).
 *   wrap                         — wrap in a <div>, for `.buttons.slideout` rows.
 */

import React from 'react';
import useOpenInSearch from '../hooks/useOpenInSearch';
import { useSlideOutButton } from './SlideOutButton';

function FindInSearchButton({ type, record, onClose, onOpenInSearch = null, variant = 'slideout', wrap = false }) {
  const { open, label } = useOpenInSearch(type, onOpenInSearch, onClose);
  useSlideOutButton([!!open, !!record]);
  if (!open || !record) return null;

  const button = variant === 'icon' ? (
    <button type="button" data-read-safe className="btn-icon" title={label} onClick={() => open(record)}>
      <span className="material-symbols-rounded">manage_search</span>
    </button>
  ) : (
    <button type="button" data-read-safe className="btn-slideout" title={label} onClick={() => open(record)}>
      <div className="icon-wrapper"><span className="material-symbols-rounded">manage_search</span></div>
      <span className="btn-label">{label}</span>
    </button>
  );
  return wrap ? <div>{button}</div> : button;
}

export default FindInSearchButton;
